if (!customElements.get('e8-card-colors')) {
  customElements.define('e8-card-colors', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.addEventListener('click', event => {
        const choice = event.target.closest('a[data-image]');
        if (!choice || !this.contains(choice) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        this.preview(choice);
      }, { signal });
      if (!this.hasAttribute('data-hover-preview')) return;
      this.addEventListener('pointerover', event => {
        const choice = event.target.closest('a[data-image]');
        if (event.pointerType === 'touch' || !choice || !this.contains(choice) || choice.contains(event.relatedTarget)) return;
        this.preview(choice);
      }, { signal, passive: true });
      this.addEventListener('focusin', event => {
        const choice = event.target.closest('a[data-image]');
        if (choice && this.contains(choice)) this.preview(choice);
      }, { signal });
    }
    preview(choice) {
      const card = this.closest('.product-card-wrapper');
      const image = card?.querySelector('.card__media .media > img');
      if (!image || !choice.dataset.image) return;
      const gallery = card.querySelector('e8-card-gallery');
      const grouped = this.hasAttribute('data-hover-preview') && gallery?.selectColor?.(choice.dataset.colorName, choice.dataset.image) === true;
      if (!grouped) {
        image.removeAttribute('srcset');
        image.src = choice.dataset.image;
        image.alt = choice.dataset.imageAlt;
        image.width = Number(choice.dataset.imageWidth);
        image.height = Number(choice.dataset.imageHeight);
        gallery?.selectColor(choice.dataset.colorName, choice.dataset.image);
      }
      card.classList.add('e8-color-selected');
      card.querySelectorAll('.card__heading a,[data-e8-card-shop]').forEach(link => { link.href = choice.href; });
      card.querySelectorAll('[data-product-url]').forEach(button => { button.dataset.productUrl = choice.href; });
      this.querySelectorAll('a').forEach(link => { link.setAttribute('aria-current', String(link === choice)); });
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
  });
}

if (!customElements.get('e8-belt-choices')) {
  customElements.define('e8-belt-choices', class extends HTMLElement {
    connectedCallback() {
      this.nativeGroup = this.querySelector('[data-e8-combined-native]');
      const controls = this.querySelector('.e8-belt-choices__controls');
      if (!this.nativeGroup || !controls) return;
      this.onChoiceClick = (event) => {
        const choice = event.target.closest('button[data-e8-color],button[data-e8-stitch]');
        if (!choice || !this.contains(choice)) return;
        const color = choice.dataset.e8Color || this.dataset.color;
        const stitch = choice.dataset.e8Stitch || this.dataset.stitch;
        const value = `${color} / ${stitch} stitching`;
        const input = Array.from(this.nativeGroup.querySelectorAll('input[type="radio"]')).find(radio => radio.value === value);
        if (!input || input.checked) return;
        this.dataset.color = color;
        this.dataset.stitch = stitch;
        this.querySelectorAll('[data-e8-color]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.e8Color === color)));
        this.querySelectorAll('[data-e8-stitch]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.e8Stitch === stitch)));
        input.click();
      };
      this.addEventListener('click', this.onChoiceClick);
      this.nativeGroup.hidden = true;
      controls.hidden = false;
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onChoiceClick);
    }
  });
}

